export default __webpack_public_path__ + "static/media/9.6bc3d79f.jpg";